import { rem as polishedRem } from 'polished';
import { size, typography } from '@scp/ui-shared/theme/variables';
export var getCSSUnitValue = function getCSSUnitValue(value) {
  return !value || isNaN(Number(value)) ? value : "".concat(value, "px");
};
export var getCurrentViewportSize = function getCurrentViewportSize() {
  return {
    width: Math.min(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.min(document.documentElement.clientHeight, window.innerHeight || 0)
  };
};
export var focusById = function focusById(id) {
  var node = document.getElementById(id);
  if (!node) return;
  node.focus();
};
/**
 * @deprecated Use `rem`, `baselineToRem`, `lineHeight` function instead
 */

export var calcEm = function calcEm(size) {
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typography.defaultFontSize;
  return size / fontSize;
};
/**
 * Calculates line-height value in unitless based on given font size.
 * @param {number} height wanted line height in pixels.
 * @param {number} fontSize font size of the parent or the same element, defaults to
 * typography.defaultFontSize.
 */

export var lineHeight = function lineHeight(height) {
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typography.defaultFontSize;
  return height / fontSize;
};
export var rem = function rem(pxValue) {
  return polishedRem(pxValue, typography.remSizeInPx);
};

var isWholeNumber = function isWholeNumber(value) {
  return value % 1 === 0;
};

export function baselineToRem(baseline) {
  if (baseline === null || baseline === 'auto') return baseline;

  if (!isWholeNumber(baseline)) {
    throw new Error('Only whole numbers are supported as baseline value!');
  }

  return rem(baseline * size.baseline);
}
export var toNumericPxValue = function toNumericPxValue(value) {
  var numericValue = typeof value === 'string' ? Number(value) : value;

  if (!numericValue || isNaN(numericValue)) {
    return undefined;
  }

  if (typeof value === 'string' && value.endsWith('rem')) {
    return numericValue * typography.remSizeInPx;
  }

  return numericValue;
};
export function baselineToPx(baseline) {
  if (baseline === null || baseline === 'auto') return baseline;

  if (!isWholeNumber(baseline)) {
    throw new Error('Only whole numbers are supported as baseline value!');
  }

  return "".concat(baseline * size.baseline, "px");
}